import fr from 'facet-rest';
import React from 'react';
import { pick } from 'Helpers/Affordances';
import PropTypes from 'prop-types';
import KnowYourCustomerVerificationButton
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/KnowYourCustomerVerificationPicker/KnowYourCustomerVerificationButton';

const KnowYourCustomerVerificationPicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.devOnlyStartKnowYourCustomerVerification.name]: (<KnowYourCustomerVerificationButton resource={resource} />),
  }, null);
};

KnowYourCustomerVerificationPicker.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default KnowYourCustomerVerificationPicker;
